








import {Component, Prop, Vue, Model} from 'vue-property-decorator';
import ClockDisplay from './ClockDisplay.vue';

@Component({
    components: {
        ClockDisplay
    }
})
export default class TimeInput extends Vue {
    
    @Model()
    value!: number;

    @Prop({ default: 30 })
    interval!: number;

    increment() {
        this.$emit('value', this.value + this.interval);
    }

    decrement() {
        this.$emit('value', this.value - this.interval);
    }
}
